module.exports = __webpack_public_path__ + "static/8-311efda9807b5d6fc79aac5bab4c496f.jpg";